// /w/:wid (and the retired /w/:wid/empire): opening a world lands on the current city, like the live game.
// The current city is the one last opened in this world (session), else the first city the worlds overview lists.
// Empire was retired on Oct 9 2026 (Slate & Action Light plan) — old bookmarks and home-screen links arrive here.
import { Navigate, useParams } from "react-router-dom";
import { Page } from "@/app/Page";
import { Card, Empty, Skeleton } from "@/kit/primitives";
import { presenceVillageId, presenceVillages, useInit } from "@/state/queries";
import { useSession } from "@/state/session";

export function WorldLanding() {
  const { wid: widP } = useParams();
  const wid = Number(widP);
  const session = useSession();
  const init = useInit();
  const sameWorld = session.wid === wid;
  const ids = presenceVillages(init.data?.world, wid).map(presenceVillageId).filter((x): x is number => !!x);
  const vid = (sameWorld && session.vid && (ids.length === 0 || ids.includes(session.vid)) ? session.vid : null) ?? ids[0] ?? (sameWorld ? session.vid : null);
  if (!Number.isInteger(wid) || wid <= 0) return <Navigate to="/worlds" replace />;
  if (vid) return <Navigate to={`/w/${wid}/city/${vid}`} replace />;
  if (init.isLoading) {
    return (
      <Page header={{ kind: "title", title: "VALOR", subtitle: `World ${wid}` }}>
        <div className="stack"><Skeleton h={220} /></div>
      </Page>
    );
  }
  if (init.isError) {
    return (
      <Page header={{ kind: "title", title: "VALOR", subtitle: `World ${wid}` }}>
        <Card><Empty>Couldn't open World {wid}. Pull down to try again, or pick another world.</Empty></Card>
      </Page>
    );
  }
  return <Navigate to="/worlds" replace />;
}
